import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

/**
 * AnalyticsTracker component.
 * Initializes Google Analytics and tracks page views on route changes.
 * 
 * Requires VITE_GOOGLE_ANALYTICS_ID environment variable to be set.
 */
const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Initialize GA4 only once
    const gaId = import.meta.env.VITE_GOOGLE_ANALYTICS_ID;
    
    if (gaId) {
      if (!window.gaInitialized) {
        ReactGA.initialize(gaId);
        window.gaInitialized = true;
        
        if (import.meta.env.DEV) {
          console.log(`GA4 Initialized with ID: ${gaId}`);
        }
      }
    } else {
        if (import.meta.env.DEV) {
            console.warn('VITE_GOOGLE_ANALYTICS_ID is missing in environment variables');
        }
    }
  }, []);

  useEffect(() => {
    // Send pageview with a custom path
    if (window.gaInitialized) {
        ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
        
        if (import.meta.env.DEV) {
            console.log(`GA4 Pageview: ${location.pathname + location.search}`);
        }
    }
  }, [location]);

  return null;
};

// Add type definition for custom window property
declare global {
  interface Window {
    gaInitialized?: boolean;
  }
}

export default AnalyticsTracker;
